<ng-template hhsg-tab-host></ng-template>
<div class="tab-footer" [style.display]="isSaveTab ? 'block' : 'none'">
    <dx-button stylingMode="contained" type="default" class="action-button" (click)="onSubmit()" [disabled]="isDisabled || !isFormDirty || !isFormValid">Save</dx-button>
    <dx-button stylingMode="outlined" type="default" class="action-button" (click)="onCancelEditing()" [disabled]="isDisabled || !isFormDirty">Cancel</dx-button>
</div>

<hhsg-shared-modal [style.display]="isSaveTab ? 'block' : 'none'"
    [isActive]="confirmSaving" 
    (acceptEvent)="onConfirmSaving()"
    (rejectEvent)="confirmSaving = false" 
    [disableFooter]="false" 
    [disableHeader]="true" 
    type="small" 
    acceptText="Yes"
    rejectText="No">
    <div role="body">
        Save changes?
    </div>
</hhsg-shared-modal>

<hhsg-shared-modal [style.display]="isSaveTab ? 'block' : 'none'"
    [isActive]="confirmCancel" 
    (acceptEvent)="onDeactivateLeavePage()"
    (rejectEvent)="confirmCancel = false" 
    [disableFooter]="false" 
    [disableHeader]="false">
    <div role="body">
        <div>Are you sure you want to cancel any unsaved changes?</div>
    </div>
    <div role="footer">
        <div class="button-group">
            <dx-button stylingMode="contained" type="default" class="action-button" (click)="onConfirmCancel()">Yes</dx-button>
            <dx-button stylingMode="outlined" type="default" class="action-button" (click)="confirmCancel = false">No</dx-button>
        </div>
    </div>
</hhsg-shared-modal>